module.exports = __webpack_public_path__ + "img/2W.cb0467ac.jpg";